// extracted by mini-css-extract-plugin
module.exports = {"container":"ShareOptions-module_container_33j-X","shareIcon":"ShareOptions-module_shareIcon_2MkDt","contentTypeText":"ShareOptions-module_contentTypeText_3EPOD"};